import { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import { useAuthorization } from "../../../hooks/useAuthorization";
import {
  getAccount,
  getAccountCategory,
  unsetSelectedAccount,
} from "../../../features/accountsSlice";
import Loading from "../../../components/loading/Loading";
import MainContainer from "../../../components/container/MainContainer";
import Modal from "../../../components/modal/Modal";
import { ChevronLeft, Save, Trash2 } from "lucide-react";
import { openModal } from "../../../features/modalSLice";
import TextContainer from "../../../components/text/TextContainer";
import PageTitle from "../../../components/titles/PageTitle";
import AddChartCategory from "./AddChartCategory";
import DeleteChartCategory from "./DeleteChartCategory";
import Table from "../../../components/tables/Table";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const SingleChartCategory = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const modalContent = useSelector((state) => state.modal.content);
  const category = useSelector(
    (state) => state.accounts.selectedAccountCategory
  );
  const loading = useSelector(
    (state) => state.accounts.load.getAccountCategory
  );

  const openEditCategoryModal = (edit, id) => {
    dispatch(openModal(<AddChartCategory edit={edit} id={id} />));
  };

  const openDeleteCategoryModal = (id) => {
    dispatch(openModal(<DeleteChartCategory id={id} />));
  };

  useLayoutEffect(() => {
    dispatch(getAccountCategory(id));

    return () => {
      dispatch(unsetSelectedAccount());
    };
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <PageTitle title={"Acct Category - " + category.name} />
      <div className="bg-content  border border-bkg2 rounded-md p-7 mb-5 !text-text-1/55">
        <TextContainer label="Name" content={category.name} />
        <TextContainer label="Account Type" content={category.account_type} />
      </div>
      <div className="table-container mt-5 ">
        <table>
          <thead>
            <tr>
              <td className="px-3 py-2 bg-gray-600 text-white">No</td>
              <td className="px-3 py-2 bg-gray-600 text-white">Name</td>
            </tr>
          </thead>
          <tbody>
            {category.id &&
              category.subCategories.map((item, index) => (
                <tr key={index}>
                  <td className="px-3">{index + 1}</td>
                  <td className="">{item.name}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="p-4 border border-bkg2 rounded-md flex justify-between items-center">
        <Link to="/settings/account-categories" className="cancel-rss-btn">
          <ChevronLeft size={18} /> Back
        </Link>
        <div className="flex gap-3">
          <button
            onClick={(e) => openEditCategoryModal(true, id)}
            disabled={!isAuthorized("accounts", "update")}
            className="add-rss-btn"
          >
            <Save size={18} />
            Edit
          </button>
          <button
            onClick={(e) => openDeleteCategoryModal(id)}
            disabled={!isAuthorized("accounts", "delete")}
            className="delete-rss-btn"
          >
            <Trash2 size={18} />
            Delete
          </button>
        </div>
      </div>
    </MainContainer>
  );
};

export default SingleChartCategory;
